import { loadPunchOutSuppliers } from "../../redux/actions/punchOutActions";
import alertDispatcher from "../../utils/alertsUtils.js";
import axiosApiInstance from "./../middleware/axios";
import {
    CANCEL_PUNCH_OUT_SESSION,
    GET_PUNCH_OUT_SUPPLIER_LIST,
    INITIATE_PUNCH_OUT_SESSION,
} from "./urls";

export const getPunchOutSupplierList = async (dispatch) => {
    /* 
    Arguments
    ---------
    dispatch : func
    */
    try {
        let request = await axiosApiInstance.get(GET_PUNCH_OUT_SUPPLIER_LIST);
        dispatch(loadPunchOutSuppliers(request.data));
    } catch (error) {
        alertDispatcher(
            "loadPunchOutSuppliers",
            error?.response?.status,
            dispatch,
            error?.response?.data?.detail
        );
    }
};

export const initiatePunchOutSession = async (
    supplierName,
    userName,
    activeOU,
    dispatch
) => {
    /* 
    Arguments
    ---------
    dispatch : func
    */
    try {
        const params = new URLSearchParams();
        params.set("userName", userName);
        params.set("org_unit", activeOU);
        let url =
            INITIATE_PUNCH_OUT_SESSION + supplierName + `?${params.toString()}`;

        let request = await axiosApiInstance.post(url);

        return request?.data ? request.data : [];
    } catch (error) {
        alertDispatcher(
            "loadPunchOutSuppliers",
            error?.response?.status,
            dispatch,
            error?.response?.data?.detail
        );
    }
};

export const cancelPunchOutSession = async (sessionId, dispatch) => {
    /* 
    Arguments
    ---------
    dispatch : func
    */
    try {
        let url = CANCEL_PUNCH_OUT_SESSION + sessionId;

        let request = await axiosApiInstance.post(url);

        return request?.data ? request.data : [];
    } catch (error) {
        alertDispatcher(
            "cancelPunchOutSession",
            error?.response?.status,
            dispatch,
            error?.response?.data?.detail
        );
    }
};
